import React from "react";
import styles from "./patientCardSkeleton.module.scss";

const SkeletonLine = ({ className = "" }: { className?: string }) => <span className={`${styles.skeleton} ${className}`} />;

export const PatientCardSkeleton = () => (
  <section className={styles.header} aria-hidden="true">
    <SkeletonLine className={styles.avatar} />
    <div className={styles.identity}>
      <SkeletonLine className={styles.name} />
      <SkeletonLine className={styles.demographics} />
      <SkeletonLine className={styles.facility} />
      <SkeletonLine className={styles.location} />
    </div>
    <SkeletonLine className={styles.moreInfo} />
  </section>
);
